import { createContext, type ReactNode } from "react";
import type { SupplierSession } from "@shared-core/data/supplier-portal-adapter";

/**
 * Lets the shared account menu (packages/portal-ui `AccountMenu`, docs/features/portal-sign-in/09 5.8) take the place of
 * the supplier portal's own menu in the header. Absent: the portal's own `WhoMenu`, as before. Mock-up phase: the signed-in
 * shell reads it; the story of the `home.*` case provides it.
 */
export const SupplierAccountMenuContext = createContext<
  ((session: SupplierSession) => ReactNode) | null
>(null);
